import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "pop_up com_pop",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "pop_tit _flex _bb" }
const _hoisted_3 = { class: "sign_form" }
const _hoisted_4 = { class: "select_date_wrap" }
const _hoisted_5 = { class: "select_date" }
const _hoisted_6 = { class: "select_date" }
const _hoisted_7 = { class: "file_wrap" }
const _hoisted_8 = { for: "area_file_popup" }
const _hoisted_9 = { class: "file_list" }
const _hoisted_10 = { class: "file_img_m" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "checkbox_wrap _blue_col" }
const _hoisted_13 = { for: "chk" }
const _hoisted_14 = { class: "checkbox_wrap _blue_col" }
const _hoisted_15 = { class: "_flex _center btn_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[15] || (_cache[15] = _createElementVNode("p", null, "팝업 배너", -1)),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _cache[16] || (_cache[16] = _createElementVNode("label", {
              for: "title",
              class: "form_li_tit"
            }, "제목", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "title",
              type: "text",
              placeholder: "제목을 입력해주세요",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form_state.title) = $event))
            }, null, 512), [
              [_vModelText, $setup.form_state.title]
            ])
          ]),
          _createElementVNode("li", null, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "form_li_tit" }, "노출기간", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form_state.startDate) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.startDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form_state.endDate) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.endDate]
                ])
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_7, [
            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "form_li_tit" }, "노출이미지", -1)),
            _createElementVNode("label", _hoisted_8, [
              _createElementVNode("input", {
                id: "area_file_popup",
                type: "file",
                placeholder: "",
                accept: "image/*",
                multiple: "",
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.handleFiles && $setup.handleFiles(...args)))
              }, null, 32),
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "file_box_wrap" }, "이미지를 등록해주세요.", -1)),
              _cache[19] || (_cache[19] = _createElementVNode("span", {
                class: "blue_btn",
                style: {"display":"flex","justify-content":"center","align-items":"center"}
              }, "파일첨부", -1))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  style: {"max-width":"100%"},
                  src: $setup.state.fileUrl ? $setup.state.fileUrl : 'img/no_img.png'
                }, null, 8, _hoisted_11)
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _cache[21] || (_cache[21] = _createElementVNode("label", {
              for: "title",
              class: "form_li_tit"
            }, "링크", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "title",
              type: "text",
              placeholder: "링크를 입력해주세요",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form_state.link) = $event))
            }, null, 512), [
              [_vModelText, $setup.form_state.link]
            ])
          ]),
          _createElementVNode("li", _hoisted_12, [
            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "form_li_tit" }, "숨김 버튼 표시", -1)),
            _createElementVNode("label", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                id: "chk",
                type: "checkbox",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form_state.isSettingClose) = $event))
              }, null, 512), [
                [_vModelCheckbox, $setup.form_state.isSettingClose]
              ]),
              _cache[22] || (_cache[22] = _createElementVNode("em", null, null, -1)),
              _cache[23] || (_cache[23] = _createElementVNode("span", null, "'오늘 하루 안보기' 표시", -1))
            ])
          ]),
          _createElementVNode("li", _hoisted_14, [
            _cache[31] || (_cache[31] = _createElementVNode("span", { class: "form_li_tit" }, "위치", -1)),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "location",
                value: "L",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form_state.location) = $event))
              }, null, 512), [
                [_vModelRadio, $setup.form_state.location]
              ]),
              _cache[25] || (_cache[25] = _createElementVNode("em", null, null, -1)),
              _cache[26] || (_cache[26] = _createElementVNode("span", null, "L", -1))
            ]),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "location",
                value: "M",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form_state.location) = $event))
              }, null, 512), [
                [_vModelRadio, $setup.form_state.location]
              ]),
              _cache[27] || (_cache[27] = _createElementVNode("em", null, null, -1)),
              _cache[28] || (_cache[28] = _createElementVNode("span", null, "M", -1))
            ]),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "location",
                value: "R",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form_state.location) = $event))
              }, null, 512), [
                [_vModelRadio, $setup.form_state.location]
              ]),
              _cache[29] || (_cache[29] = _createElementVNode("em", null, null, -1)),
              _cache[30] || (_cache[30] = _createElementVNode("span", null, "R", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "submit_btn _130 _gray",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
          }, "취소"),
          ($setup.props.isEdit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "submit_btn _130 _main_blue",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.modify && $setup.modify(...args)))
              }, "수정"))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "submit_btn _130 _main_blue",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ($setup.add && $setup.add(...args)))
              }, "저장"))
        ])
      ])
    ])
  ], 64))
}